import Vue from 'vue'
import Configurator from './Configurator.vue'
import router from './router'
//import router from 'vue-router'


window.vi = new Vue({
  router,
  render: h => h(Configurator)
}).$mount('#wn-conf');


/*
new Vue({
  el: "#wn-conf",
  router,
  template: Configurator
}
*/